module.exports = __webpack_public_path__ + "static/media/a.d55bddf.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/a.mp4
// module id = n/uR
// module chunks = 1